import {getBalance} from './balanceQueries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {generateClient} from "aws-amplify/api";

export type BalanceSourceTypes = {
    bankAccount?: number,
    card?: number,
    fpx?: number,
}

export type BalanceAmount = {
    amount: number,
    currency: string,
    sourceTypes?: BalanceSourceTypes,
}

export type Balance = {
    available: BalanceAmount[],
    connectReserved?: BalanceAmount[],
    instantAvailable?: BalanceAmount[],
    livemode?: boolean,
    pending: BalanceAmount[],
}

export type GetBalance = {
    getBalance: Balance
}

const client = generateClient();

export const fetchBalance = async () => {
    const response = await client.graphql<GraphQLQuery<GetBalance>>({
                                                                         query: getBalance,
                                                                     });
    return response.data?.getBalance;
};
